import useTicket from "@/hooks/useTicket";
import useMundialeChat from "@/hooks/useMundialeChat";
import RechargeFinishedView from "./view";
import { useNavigate } from "react-router-dom";

export default function RechargeFinished() {
  useMundialeChat();

  const navigate = useNavigate();
  const {
    isLoading,
    openPaymentReceipt,
    generatePDF,
    invoice,
    toggleModal,
    isVisibleModal,
    errorTickets,
    errorInvoice,
  } = useTicket();

  const goBack = () => gotToHome();

  const gotToHome = () => navigate("/");

  const openInvoice = () => {
    openPaymentReceipt();
  };

  return (
    <RechargeFinishedView
      goBack={goBack}
      gotToHome={gotToHome}
      invoice={invoice}
      toggleModal={toggleModal}
      generatePDF={generatePDF}
      isVisibleModal={isVisibleModal}
      isLoading={isLoading}
      openInvoice={openInvoice}
      error={errorTickets || errorInvoice}
      toggleError={toggleModal}
    />
  );
}
